import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendApplePaymentToken } from '../../api/applePay'
import { sendGooglePaymentToken } from '../../api/googlePay'
import { getOrders, getQrCart, getRoutePrice } from '../../api/qr'
import { CLIENT_CODE } from '../../config/LSvars'
import { isProdEnv } from '../../utils/env'
import { throwError } from '../../utils/error'
import { setTestTotalPrice } from '../slices/qr'

export const fetchRoutePrice = createAsyncThunk(
  'fetchRoutePrice',
  async (params, thunkAPI) => {
    const {
      qr: { from_stop_id, to_stop_id, currentRoute },
    } = thunkAPI.getState()
    const { route_rule_id } = currentRoute
    if (!route_rule_id) throw Error('cannot find route_rule_id')

    const data = await getRoutePrice({ from_stop_id, to_stop_id, route_rule_id })
    // console.log(data)
    return data
  },
)

export const fetchQrCart = createAsyncThunk('fetchQrCart', async (params, thunkAPI) => {
  const {
    qr: { routePrice, currentRoute, qrAmount },
  } = thunkAPI.getState()
  const { route_rule_id } = currentRoute
  const { price, product_id } = routePrice
  if (!route_rule_id) throwError('cannot find route_rule_id')
  if (!product_id || !price) throwError('cannot find product_id or price')

  const client_code = localStorage.getItem(CLIENT_CODE)

  let testPrice = 0
  if (!isProdEnv) {
    testPrice = Number(prompt('Введіть тестову суму оплати:', 0.1))
    thunkAPI.dispatch(setTestTotalPrice(testPrice))
  }

  const data = await getQrCart({
    // carrier_id: 1,
    route_rule_id,
    quantity: qrAmount,
    price: isProdEnv ? price : testPrice,
    product_id,
    client_code,
  })
  // console.log(data)
  return data
})

export const payWithGoogle = createAsyncThunk('payWithGoogle', async (params, thunkAPI) => {
  const {
    qr: { qrCart },
  } = thunkAPI.getState()
  const { token } = params
  const { order_code } = qrCart
  // return []
  if (!token) throwError('cannot find GooglePay token')
  if (!order_code) throwError('cannot find order_code')

  const data = await sendGooglePaymentToken({ order_code, token })
  // console.log(data)
  return data
})

export const payWithApple = createAsyncThunk('payWithApple', async (params, thunkAPI) => {
  const {
    qr: { qrCart },
  } = thunkAPI.getState()
  const { token } = params
  const { order_code } = qrCart
  // return []
  if (!token) throwError('cannot find ApplePay token')
  if (!order_code) throwError('cannot find order_code')

  const data = await sendApplePaymentToken({ order_code, token })
  // console.log(data)
  return data
})

export const fetchOrders = createAsyncThunk('fetchOrders', async (params, thunkAPI) => {
  const client_code = localStorage.getItem(CLIENT_CODE)
  const {
    qr: { qrCart },
  } = thunkAPI.getState()
  const { order_code } = qrCart

  let reqParams = {}
  if (client_code) reqParams = { client_code }
  else reqParams = { order_code }

  if (!client_code && !order_code) throwError('cannot find client_code or order_code')

  const data = await getOrders(reqParams)
  // console.log(data)
  return data
})
